import React from "react";
import { t } from "ttag";

import { IOrder } from "../../../models/checkout.interfaces";
import format from "../../../utils/format";

interface IProps {
    order: IOrder;
    disableFreeShippingMessage?: boolean;
}

interface IState {}

// TODO(ssr, LEVEL 2 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 2/10 due to 66 LOC, primarily presentational with simple calculations (discounts, tax), and straightforward rendering. Very simple migration candidate.
export class OrderSummary extends React.Component<IProps, IState> {
    // TODO(i18n): buildRow should not accept pre-translated label string; it prevents proper context and forces early translation. Consider accepting a translation key or element instead.
    private buildRow(label: string, value: string) {
        return (
            <span className="basket-summary-line">
                <dt className="basket-summary-line__title">{label}</dt>
                <dd className="basket-summary-line__data">{value}</dd>
            </span>
        );
    }

    render() {
        const totalDiscount =
            this.props.order.basket_total_before_discounts_excl_tax.subtract(
                this.props.order.basket_total_excl_tax,
            );
        const totalTax = this.props.order.total_incl_tax.subtract(
            this.props.order.total_excl_tax,
        );
        return (
            <div className="">
                <dl className="basket-summary__prices">
                    {/* TODO(i18n): Translation happens too early; label is translated before being passed to buildRow, preventing context-aware translation */}
                    {this.buildRow(
                        t`Subtotal`,
                        format.money(
                            this.props.order
                                .basket_total_before_discounts_excl_tax,
                        ),
                    )}
                    {/* TODO(i18n): Translation happens too early; label is translated before being passed to buildRow, preventing context-aware translation */}
                    {!totalDiscount.isZero() &&
                        this.buildRow(
                            t`Total Savings`,
                            format.money(totalDiscount),
                        )}
                    {/* TODO(i18n): Translation happens too early; label is translated before being passed to buildRow, preventing context-aware translation */}
                    {this.buildRow(
                        t`Shipping`,
                        format.money(this.props.order.shipping_incl_tax),
                    )}
                    {/* TODO(i18n): Translation happens too early; label is translated before being passed to buildRow, preventing context-aware translation */}
                    {this.buildRow(t`Tax`, format.money(totalTax))}
                    {/* TODO(i18n): Translation happens too early; label is translated before being passed to buildRow, preventing context-aware translation */}
                    {this.buildRow(
                        t`Total`,
                        format.money(this.props.order.total_incl_tax),
                    )}
                </dl>
            </div>
        );
    }
}
